export * from './input-img-file.component';
export * from './input-img-file.module';
